<template>
  <div>
    <PickupPointSelector
        :disabled="setProcess"
        :loading="loading"
        :pickup-points="pickupPoints"
        :selected-id="defaultPickupPointId"
        :selected-ts="selectedTs"
        :setted-by-admin="settedByAdmin"
        @select="setPickupPoint"
    ></PickupPointSelector>

    <Info
        v-if="error"
        :error="error"
    ></Info>

    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-btn
            color="red"
            text
            type="button"
            :disabled="setProcess"
            @click="$router.go(-1)"
        >
          Назад
        </v-btn>
        <v-btn
            color="primary"
            text
            type="submit"
            :disabled="setProcess || !defaultPickupPointId"
            :loading="setProcess"
            @click="defaultPickupPointSet"
        >
          Выбрать
        </v-btn>
      </v-col>
    </v-row>

    <PageInfo
        title="Выберите точку выдачи по умолчанию"
        description="Все новые заказы текущей группы будут отправлены на нее"
    ></PageInfo>
  </div>
</template>

<script>
import Info from '@/components/Info'
import PageInfo from '@/components/PageInfo'
import PickupPointSelector from '@/components/PickupPointSelector'
import {showToast} from '@/services/utils'

export default {
  name: 'UserProfilePickupPoint',
  components: {PageInfo, Info, PickupPointSelector},
  created () {
    Promise.all([
      this.$client.get(this.$API.PICKUP_POINTS.LIST, {params: {sourceId: this.sourceId}}),
      this.$client.get(this.$API.PICKUP_POINTS.DEFAULT.GET, {params: {sourceId: this.sourceId}})
    ])
        .then(([pPList, ppDefault]) => {
      this.pickupPoints = pPList.items
      if (ppDefault) {
        this.defaultPickupPointId = ppDefault.id
        this.selectedTs = ppDefault.ts
        this.settedByAdmin = ppDefault.settedByAdmin
      }
    })
        .catch(err => this.error = err)
        .finally(() => this.loading = false)
  },
  data () {
    return {
      defaultPickupPointId: null,
      error: null,
      loading: true,
      pickupPoints: [],
      selectedTs: null,
      setProcess: false,
      settedByAdmin: false
    }
  },
  methods: {
    setPickupPoint (item) {
      this.defaultPickupPointId = item.id
    },
    defaultPickupPointSet ()  {
      this.error = null
      this.setProcess = true
      this.$client.post(this.$API.PICKUP_POINTS.DEFAULT.SET, {sourceId: this.sourceId, id: this.defaultPickupPointId})
        .then(rs => {
          this.selectedTs = rs.ts
          this.settedByAdmin = rs.settedByAdmin
          showToast('Точка выдачи выбрана')
        })
        .catch(err => this.error = err)
        .finally(() => this.setProcess = false)
    }
  },
  props: {
    sourceId: {
      required: true,
      type: String
    }
  }
}
</script>

<style scoped>

</style>